module.exports = __webpack_public_path__ + "static/img/alipay.29e2fef.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/alipay.jpg
// module id = 5r33
// module chunks = 0